import { isArray, isEmpty, isFunction, isObject, isString } from '../../is';
import { toObject } from '..';
import { patternsParser } from './parser';

export function fromObject(source, targetConfig) {
  const entries = targetConfig.map(e => {
    // TODO prop解析
    const _source = isEmpty(source[e.prop]) ? e.initValue : source[e.prop];
    let res = [e.newProp || e.prop, _source];
    if (isArray(e.children) && _source instanceof Object) {
      if (isArray(_source)) {
        res[1] = fromArray(_source, e.children);
      } else if (isObject(_source)) {
        res[1] = fromObject(_source, e.children);
      }
    }
    if (isFunction(e.handler)) res[1] = e.handler(res[1], source, targetConfig);
    return res;
  });
  return toObject(entries);
}

export function fromArray(source, target) {
  if (!isArray(source)) return [];
  const res = source.map(e => {
    return isObject(e) ? fromObject(e, target) : null;
  });
  return res.filter(Boolean);
}

export function struct(source, targetConfig) {
  if (!targetConfig) return source;
  const _targetConfig = isString(targetConfig) ? patternsParser(targetConfig) : targetConfig;
  let res;
  if (isArray(source)) {
    res = fromArray(source, _targetConfig);
  } else if (isObject(source)) {
    res = fromObject(source, _targetConfig);
  }
  return res;
}
